import { createCategoriesApi } from '@/v2/api/metadata/categories'
import { createSportsApi } from '@/v2/api/metadata/sports'
import { createTournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import { createTournamentsApi } from '@/v2/api/metadata/tournaments'
import type { BackofficeContext } from '@/v2/framework/context/types'
import type { EntityView } from '@/v2/framework/view/types'
import { columns, dynamicColumnSlots } from './columns'
import { createFilters } from './filters'
import { createDialogs } from './dialogs'

const LS_TOURNAMENTS_FILTERS_KEY = Symbol('tournaments-filters')

export function createTournamentsView(ctx: BackofficeContext): EntityView {
  const tournamentsApi = createTournamentsApi(ctx)
  const sportsApi = createSportsApi(ctx)
  const categoriesApi = createCategoriesApi(ctx)
  const roundsApi = createTournamentRoundsApi(ctx)

  return {
    id: 'tournaments',
    view: [
      {
        type: 'grid',
        columns,
        filters: createFilters({ ctx, sportsApi, categoriesApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, tournamentsApi, sportsApi, categoriesApi, roundsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_TOURNAMENTS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: tournamentsApi.grid,
      },
    ],
  }
}
